/**
 * URL of the public voting page, as put in the QR code. Uses the short registration host when it is
 * configured (smaller QR, no "admin" in the address), like the badge QR does.
 */
const configured = (import.meta.env.VITE_PUBLIC_REGISTRATION_URL as string | undefined)?.replace(/\/+$/, '');

export function votingPublicUrl(electionId: string, roomToken?: string): string {
  const origin = configured ? new URL(configured).origin : window.location.origin;
  return `${origin}/v/${electionId}${roomToken ? `?t=${encodeURIComponent(roomToken)}` : ''}`;
}

const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

/** The badge QR holds https://…/p/<token>; returns the token, or null if the text is something else */
export function badgeTokenFromScan(text: string): string | null {
  return text.match(UUID)?.[0]?.toLowerCase() ?? null;
}
